module.exports = __webpack_public_path__ + "img/uy.6720b2e4.svg";